module.exports = "\n<div v-if=\"show\" class=\"modal\" _v-4e47114f=\"\">\n  <div class=\"shadow\" _v-4e47114f=\"\">\n    <span class=\"icon\" _v-4e47114f=\"\"></span>\n    <p class=\"message\" _v-4e47114f=\"\">{{message}}</p>\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-4e47114f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/dialog/MessageBox.vue
// module id = 2483
// module chunks = 38